/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const dog = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g clipPath="url(#dog_svg__a)">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M4.966 2.267c.066.224.073.468 0 .716A18.384 18.384 0 0 1 3.48 6.577c-.34.645-1.298.656-1.654.02C1.208 5.503.616 3.95 1.32 2.782a3.093 3.093 0 0 1 1.968-1.514c.738-.166 1.479.323 1.679.999Zm0 0c.441-.344.863-.691 1.383-.917a4.307 4.307 0 0 1 3.299-.042c.531.214.97.546 1.406.907m0 0c-.082.244-.096.51-.02.768a18.388 18.388 0 0 0 1.486 3.594c.333.632 1.296.66 1.654.02.618-1.094 1.21-2.646.507-3.815-.475-.877-1.622-1.802-2.679-1.491a1.453 1.453 0 0 0-.948.924ZM3.195 10c.381 1.698 1.117 3.207 2.258 4.113 1.49 1.183 3.703 1.183 5.192 0 1.14-.906 1.877-2.415 2.258-4.113M5.985 6.664h.023m3.977 0h.023m-.549 4.126c0 .517-.631.936-1.41.936-.779 0-1.41-.419-1.41-.936 0-.517.631-.936 1.41-.936.779 0 1.41.419 1.41.936Z"
      />
    </g>
    <defs>
      <clipPath id="dog_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default dog
